import type { Ticket } from '@localagent/sdk';
import { useTeams } from '../../hooks/useWorkManagement';
import {
  TICKET_STATE_LABELS,
  TICKET_STATUS_LABELS,
  STATE_COLORS,
  PRIORITY_LABELS,
  PRIORITY_COLORS,
} from '../../lib/work-management-helpers';

interface TicketContextPanelProps {
  ticket: Ticket;
}

export function TicketContextPanel({ ticket }: TicketContextPanelProps) {
  const { data: teams } = useTeams();
  const team = teams?.find(t => t.id === ticket.team_id);

  return (
    <div className="space-y-3">
      <div>
        <span className="font-mono text-xs text-primary cursor-pointer hover:underline">
          {ticket.identifier}
        </span>
        <h3 className="text-sm font-medium mt-1 leading-tight">{ticket.title}</h3>
      </div>

      <div className="flex flex-wrap gap-1.5">
        <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${STATE_COLORS[ticket.state]}`}>
          {TICKET_STATE_LABELS[ticket.state]}
        </span>
        {ticket.status && (
          <span className="inline-flex items-center rounded-full bg-muted px-2 py-0.5 text-xs font-medium">
            {TICKET_STATUS_LABELS[ticket.status] || ticket.status}
          </span>
        )}
        {ticket.priority !== 'none' && (
          <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${PRIORITY_COLORS[ticket.priority]}`}>
            {PRIORITY_LABELS[ticket.priority]}
          </span>
        )}
      </div>

      {team && (
        <div className="text-xs text-muted-foreground">
          Team: {team.name}
        </div>
      )}

      {ticket.description && (
        <p className="text-xs text-muted-foreground line-clamp-4">{ticket.description}</p>
      )}
    </div>
  );
}
